import React from 'react';
import { findVisitorEngagementLevel } from '../Sunburst/utilsSunburst';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';
import { getFormattedNumber } from '../../../../Util/numberFormats';
import styles from '../Sunburst.module.css';

function TableData({ data, id, }) {

	function findFnLabel(id,item){ 
		if (id === 'topUrls') return  item;
		if (id === 'topTraffics') return item;
		if (id === 'topVisEngLevels') return findVisitorEngagementLevel(item);
	}

	const hasData = Array.isArray(data) && data.length > 0;

	return (
		<>
			{hasData &&
				<div className={styles.table}>
					{data.map((item, i) => {
						const label = findFnLabel(id,item.id);
						return (
							<div key={item.id} className={styles.table_row}>
								<div className={styles.table_col_rank}>{i + 1}.</div>
								<div className={styles.table_col_label}>{label}</div>
								<div className={styles.table_col_value}>{getFormattedNumber(item.count)}</div>
							</div>
						);
					})}
				</div>
			}
			{!hasData &&
				<EmptyState
					textSize="s"
					verticalSize="s"
					text={'No data'}
				/>
			}
		</>
	);
}

export default TableData;